// @ts-check
/**
 * @typedef PlayerListModel
 * @property {string} name - player name
 * @property {import('./player.api').TPlayerTeamEnum} teamEnum - team enum
 * @property {{[marketId:number]: import('./player-outcome.model').default}} markets - player markets map -> outcome 
 * @property {{[outcomeIdentifier:string]:import('./player-outcome.model').default}} outcomes - player grouped outcome map -> outcome
 * @property {string} [sbv] - optional properity if player has sbv for grouped outcomes
 */

/**
 * @typedef GroupedOutcomesModel
 * @property {string} name - outcome name
 * @property {string} id - outcome identifier (ocn)
 * @property {number} column - outcome column
 */

export default class PlayerTabGroupModel {
  /**
   * @param {string} name - player group name
   */
  constructor(name) {
    /**
    * Market Group Name
    * @type {string}
    */
    this.name = name;
    /**
     * List of simple markets if any
     * @type {import('./player-market.model').default[]}
     */
    this.simpleMarkets = [];
    /**
     * List of grouped markets if any
     * This is just markets the outcomes here are in player list part
     * @type {import('./player-market.model').default[]}
     */
    this.groupedMarkets = [];
    /**
     * List of grouped outcomes if any
     * Used when complex Market
     * @type {GroupedOutcomesModel[]}
     */
    this.groupedOutcomes = [];
    /**
     * List of grouped players for this market group
     * @type {PlayerListModel[]}
     */
    this.playersList = [];
    /**
     * Complex market we need this when we have grouped outcomes
     * @type {import('./player-market.model').default|null}
     */
    this.complexMarket = null;
    /**
     * Flag to indicate if any market in this market group has cashout
     * @type {boolean}
     */
    this.hasCashout = false;
    /**
     * Market group order
     * @type {number}
     */
    this.order = 0;
  }
}